module.exports = __webpack_public_path__ + "static/media/ml.268f95f6.svg";